import React from 'react';
import classNames from 'classnames';
import SvgIcon from '../SvgIcon';

/**
 * @ignore - internal component.
 */
function Rolling(props) {
  const { pause, prefixCls, className, ...other } = props;
  return (
    <SvgIcon
      {...other}
      className={classNames(prefixCls, { [`${prefixCls}-static`]: pause }, className)}>
      <circle
        fill="none"
        strokeWidth="2"
        strokeDasharray="39.6 12.6"
        strokeLinecap="round"
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"/>
    </SvgIcon>
  );
}
Rolling.defaultProps = {
  prefixCls: 'ne-rolling',
};
export default React.memo(Rolling);



// WEBPACK FOOTER //
// ./src/icons/internals/Rolling.jsx